import { useState, useEffect, useMemo } from 'react'
import { PageHeader, SearchInput, Modal, EmptyState } from '../components/UI'
import { get, post } from '../utils/api'
import { IconPlus, IconAddressBook } from '@tabler/icons-react'

export default function ContactsPage() {
  const [contacts, setContacts] = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [showAdd, setShowAdd] = useState(false)
  const [formData, setFormData] = useState({})
  const [saving, setSaving] = useState(false)

  const load = async () => { try { setContacts(await get('/contacts')) } catch {} finally { setLoading(false) } }
  useEffect(() => { load() }, [])

  const filtered = useMemo(() => {
    if (!search) return contacts
    const s = search.toLowerCase()
    return contacts.filter(c => c.name.toLowerCase().includes(s) || (c.company||'').toLowerCase().includes(s) || (c.email||'').toLowerCase().includes(s))
  }, [contacts, search])

  const handleCreate = async () => {
    setSaving(true)
    try { await post('/contacts', formData); setShowAdd(false); setFormData({}); load() }
    catch (err) { alert(err.message) } finally { setSaving(false) }
  }

  if (loading) return <div className="text-center py-5"><div className="spinner-border text-primary" /></div>

  return (
    <>
      <PageHeader title="Contacts" subtitle={`${contacts.length} contacts`}
        actions={<button className="btn btn-primary btn-sm" onClick={() => setShowAdd(true)}><IconPlus size={16} className="me-1" />New Contact</button>} />
      <div className="d-flex mb-3"><SearchInput value={search} onChange={setSearch} placeholder="Search contacts..." /></div>
      {filtered.length === 0 ? <EmptyState icon={IconAddressBook} title="No contacts found" /> : (
        <div className="card">
          <div className="table-responsive">
            <table className="table table-vcenter card-table table-hover">
              <thead><tr><th>Name</th><th>Company</th><th>Email</th><th>Phone</th><th>Title</th><th>Location</th></tr></thead>
              <tbody>{filtered.map(c => (
                <tr key={c.id}><td className="fw-medium">{c.name}</td><td>{c.company}</td><td>{c.email}</td><td>{c.phone}</td><td>{c.title}</td><td>{c.city}{c.state ? `, ${c.state}` : ''}</td></tr>
              ))}</tbody>
            </table>
          </div>
        </div>
      )}
      <Modal open={showAdd} onClose={() => setShowAdd(false)} title="New Contact" wide>
        <div className="row g-3">
          {[{label:'Name',key:'name'},{label:'Company',key:'company'},{label:'Email',key:'email'},{label:'Phone',key:'phone'},
            {label:'Title',key:'title'},{label:'City',key:'city'},{label:'State',key:'state'}].map(f => (
            <div key={f.key} className="col-md-6">
              <label className="form-label">{f.label}</label>
              <input className="form-control" value={formData[f.key]||''} onChange={e => setFormData({...formData,[f.key]:e.target.value})} />
            </div>))}
          <div className="col-12"><label className="form-label">Notes</label><textarea className="form-control" rows={2} value={formData.notes||''} onChange={e => setFormData({...formData,notes:e.target.value})} /></div>
        </div>
        <div className="d-flex justify-content-end gap-2 mt-4">
          <button className="btn" onClick={() => setShowAdd(false)}>Cancel</button>
          <button className="btn btn-primary" disabled={saving} onClick={handleCreate}>{saving?'Creating...':'Create'}</button>
        </div>
      </Modal>
    </>
  )
}
